import { get, post, del } from '@/shared/utils/fetchApi';

// Cliente da fila do Engine (workflow-executions no apps/service/BullMQ) para a
// aba Engine do painel de Queues do Superadmin (AB#84619). Endpoints exclusivos
// da api v2 — sem fallback legacy.

export interface EngineQueueJob {
  id: string;
  state: string;
  executionId: string | null;
  agentVersionId: string | null;
  agentName: string | null;
  triggerType: string | null;
  attemptsMade: number;
  enqueuedAt: string | null;
  finishedAt: string | null;
  failedReason: string | null;
}

export interface EngineQueueSnapshot {
  metrics: Record<string, number>;
  jobs: EngineQueueJob[];
}

export const getEngineQueueSnapshot = (limit = 50): Promise<EngineQueueSnapshot> =>
  get<EngineQueueSnapshot>(`/engine/queue/snapshot?limit=${limit}`);

export const retryEngineQueueJob = (jobId: string): Promise<{ success: boolean }> =>
  post<{ success: boolean }>(`/engine/queue/jobs/${encodeURIComponent(jobId)}/retry`);

export const removeEngineQueueJob = (jobId: string): Promise<{ success: boolean }> =>
  del<{ success: boolean }>(`/engine/queue/jobs/${encodeURIComponent(jobId)}`);
